import React from "react";
import "./styles.css";
import tecnomylLogo from "../../assets/img/Logo_Tecnomyl.png";
import argentina from "../../assets/img/bandera.png";

const Header = (props) => {
  const product = props.product;
  const isMobile = window.innerWidth < 767 ? true : false;
  return (
    <header
      style={{
        backgroundImage:
          "url(" +
          process.env.PUBLIC_URL +
          "/img/products/" +
          (isMobile ? product.bgHeaderMobile : product.bgHeader) +
          ")",
      }}
    >
      <div className="col">
        <div className="container">
          <div className="row">
            <div className="col text-center d-md-flex justify-content-between my-2">
              <a href="/">
                <img src={tecnomylLogo} alt="Tecnomyl" id="tecnomyl-logo" />
                </a>
                <img src={argentina} alt="Argentina" id="argentina" />
              
            </div>
          </div>
          <div className="row pt-3 pt-md-5">
            <div className="col-md-6 text-center text-md-left">
              <img
                src={process.env.PUBLIC_URL + "/img/products/" + product.logo}
                alt={product.name}
                id="product-logo"
              />
              <h2>{product.subtitle}</h2>
            </div>
            <div className="col-md-6 text-center text-md-left">
              <div className="row">
                <div className="col-md-6 p-0">
                  <img
                    className="img-fluid"
                    src={
                      process.env.PUBLIC_URL + "/img/products/" + product.img
                    }
                    alt={product.name}
                    id="bidon"
                  />
                </div>
                <div className="col-md-4 p-0">
                  <div id="description" className="bg-green-light p-md-3">
                    <div>
                      <h6>Composición</h6>
                      <p>{product.composition}</p>
                    </div>
                    <div>
                      <h6>Formulación</h6>
                      <p>{product.formula}</p>
                    </div>
                    <div>
                      <h6>Modo de Acción</h6>
                      <p>{product.actionMode}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
